import * as React from 'react';

import type { ModificationProps } from 'bundles/ent-website/contentful/modules/MarketoModule';

type PortalProps = {
  assetUrl: string | undefined;
};

export const ASSET_DOWNLOAD_SELECTOR = 'asset_download';

const AssetDownloadLink = ({ assetUrl }: PortalProps) => {
  if (!assetUrl) {
    return null;
  }

  return (
    <div style={{ display: 'none' }}>
      {/* Surpressing this warning because it's aria-hidden + hidden. The screen readers should not read this. */}
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <a aria-hidden className={ASSET_DOWNLOAD_SELECTOR} target="_blank" href={assetUrl} rel="noreferrer" />
    </div>
  );
};

const downloadAsset = ({ mktoFormId }: ModificationProps) => {
  const downloadElement = document.querySelector<HTMLAnchorElement>(
    `#mktoForm_${mktoFormId} a.${ASSET_DOWNLOAD_SELECTOR}`
  );

  if (!downloadElement) {
    return false;
  }

  window.open(downloadElement?.href, '_blank');
  return true;
};

export { downloadAsset, AssetDownloadLink };
